import { useCallback, useEffect, useState } from "react";
import { notify } from "../../../assets/helpers/toast";
import { Header } from "../../common/Header/Header";
import { ActionButton } from "../../common/Buttons/Buttons";
import {
  BatteryApplicationTable,
  BatterySalesTable,
} from "../../common/Tables/Tables";
import {
  batteryApplicationTableHeader,
  batterySalesTableHeader,
} from "../../../assets/helpers/tables";
import { LoadSpinner } from "../../common/LoadSpinner/LoadSpinner";
import { UploadBatteryInventoryModal } from "../../common/Modals/Modals";
import { FilterButton } from "../Stats/Exportables/Exportables";
import { BatterySalesService } from "../../../services/batterySalesService";
import { useDropzone } from "react-dropzone";

export const BatterySales = () => {
  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      if (
        ![
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
        ].includes(file.type)
      ) {
        notify("Por favor, sube un archivo de Excel (.xlsx o .xls)", "error");
        return null;
      }
      let maxWeight = 5; // Puedes cambiar este valor
      if (file.size * 0.000001 > maxWeight) {
        notify(
          `El archivo de Excel no debe superar los ${maxWeight} MB`,
          "error"
        );
      } else {
        setFileUploaded(file);
      }
    });
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const [fileUploaded, setFileUploaded] = useState("");
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [batterySalesData, setBatterySalesData] = useState({
    limit: 50,
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    description: "",
    type: "Inventario",
  });

  const [batteryApplicationData, setBatteryApplicationData] = useState({
    limit: 50,
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    description: "",
    type: "",
  });

  const handlePageChange = (event, value) => {
    setBatterySalesData((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * batterySalesData?.limit,
      };
    });
  };

  const handlePageChangeApplicative = (event, value) => {
    console.log(value, batteryApplicationData?.limit);
    setBatteryApplicationData((prevState) => ({
      ...prevState,
      page: value,
      offset: (value - 1) * batteryApplicationData?.limit,
    }));
  };

  const handleCloseModal = () => {
    setShowUploadModal(false);
    setFileUploaded("");
  };

  const handleShowModal = () => {
    setShowUploadModal(true);
  };

  const appendFile = (file) => {
    const formData = new FormData();
    formData.append("inventoryFile", file);
    formData.append("fileName", file.name);
    return formData;
  };

  const createBatterySales = async () => {
    let fileToPost = appendFile(fileUploaded);
    await BatterySalesService.setInventory(fileToPost).then((response) => {
      if ([200, 201].includes(response.status)) {
        if (response?.data?.fileErrors) {
          notify(
            `El archivo contiene errores, se han actualizado solo los datos correctos`,
            "error"
          );

          const link = document.createElement("a");
          link.href = response?.data?.fileErrors?.file;
          link.setAttribute("download", "errores.xlsx"); // any other extension
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          handleCloseModal();
          getBatterySales();
        } else {
          notify(`Archivo cargado con exito`, "success");
          handleCloseModal();
          getBatterySales();
        }
      } else {
        notify(`${response.message}`, "error");
      }
    });
  };

  const selectTypeApplicative = (type) => {
    setBatterySalesData((prevState) => {
      return {
        ...prevState,
        type: "",
      };
    });

    setBatteryApplicationData((prevState) => {
      return {
        ...prevState,
        type: type,
      };
    });
  };

  const selectType = (type) => {
    setBatteryApplicationData((prevState) => {
      return {
        ...prevState,
        type: "",
      };
    });

    setBatterySalesData((prevState) => {
      return {
        ...prevState,
        type: type,
      };
    });
  };

  const getBatterySales = () => {
    setIsLoading(true);

    if (batteryApplicationData?.type === "Aplicativo") {
      BatterySalesService.getApplicative({
        limit: batteryApplicationData?.limit,
        offset: batteryApplicationData?.offset,
      })
        .then((response) => {
          if (response.status === 200) {
            setBatteryApplicationData((prevState) => {
              return {
                ...prevState,
                data: response?.data?.aplicative,
                count: response?.data?.total,
              };
            });
            setIsLoading(false);
          } else {
            notify(`${response.message}` || "error", "error");
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }

    if (batterySalesData?.type === "Inventario") {
      BatterySalesService.getInventory({
        limit: batterySalesData?.limit,
        offset: batterySalesData?.offset,
      })
        .then((response) => {
          if (response.status === 200) {
            setBatterySalesData((prevState) => {
              return {
                ...prevState,
                data: response?.data?.inventory,
                count: response?.data?.total,
              };
            });
            setIsLoading(false);
          } else {
            notify(`${response.message}` || "error", "error");
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
    return true;
  };

  useEffect(() => {
    getBatterySales();
  }, [
    batterySalesData?.page,
    batterySalesData?.offset,
    batterySalesData?.limit,
    batterySalesData?.type,
    batteryApplicationData?.page,
    batteryApplicationData?.offset,
    batteryApplicationData?.limit,
    batteryApplicationData?.type,
  ]);

  return (
    <>
      <Header />
      <LoadSpinner show={isLoading} />
      <UploadBatteryInventoryModal
        show={showUploadModal}
        handleCloseModal={handleCloseModal}
        fileUploaded={fileUploaded}
        getRootProps={getRootProps}
        getInputProps={getInputProps}
        setFileUploaded={setFileUploaded}
        message="Arrastrar documento"
        upload={createBatterySales}
      />

      <div className="service-with-container container">
        <div
          className=""
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h1 className="title-component">Venta de Baterías</h1>
        </div>
        <div
          className="breadcrumb-container"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: "1%",
          }}
        >
          <div
            className="providers-buttons-container"
            style={{
              width: "50%",
              justifyContent: "left",
              gap: "1%",
            }}
          >
            <FilterButton
              label={"Aplicativo"}
              type={batteryApplicationData?.type}
              action={selectTypeApplicative}
            />
            <FilterButton
              label={"Inventario"}
              type={batterySalesData?.type}
              action={selectType}
            />
          </div>
          {batterySalesData.type === "Inventario" && (
            <ActionButton
              action={() => handleShowModal()}
              label={"Cargar inventario"}
            />
          )}
        </div>
        <div className="gray-line"></div>
        <div className="filter-button-container"></div>
        <br />
        {batteryApplicationData?.type === "Aplicativo" && (
          <BatteryApplicationTable
            header={batteryApplicationTableHeader}
            dataTable={batteryApplicationData}
            handlePageChange={handlePageChangeApplicative}
          />
        )}
        {batterySalesData?.type === "Inventario" && (
          <BatterySalesTable
            header={batterySalesTableHeader}
            dataTable={batterySalesData}
            handlePageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
};
